import {FC, useRef, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_Montdor/layout/core'
import * as auth from './AuthRedux'
// import {getUserByToken} from './AuthCRUD'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // Rehydrate token from localStorage if needed (legacy), then optional user fetch.
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          props.restoreSessionFromStorage()
          // const {data: user} = await getUserByToken(accessToken as string)
          // props.fulfillUser(user)
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          props.logout()
        }
      } finally {
        didRequest.current = true
        setShowSplashScreen(false)
      }
    }

    requestUser()
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
